export default function getContentMessageId(isCreateAccountActive) {
  return {
    pageTitle: isCreateAccountActive
      ? 'pinLogin.flowCreateAccount.pageTitle'
      : 'pinLogin.pageTitle',
    pinNumberTitle: isCreateAccountActive
      ? 'pinLogin.flowCreateAccount.pinNumber.title'
      : 'pinLogin.pinNumber.title',
    qrCodeTitle: isCreateAccountActive
      ? 'pinLogin.flowCreateAccount.qrCode.title'
      : 'pinLogin.qrCode.title',
    qrCodeDescription: isCreateAccountActive
      ? 'pinLogin.flowCreateAccount.qrCode.text'
      : 'pinLogin.qrCode.text',
  };
}
